import { Transition } from '@uirouter/core';
import * as fromShared from '../shared';
import { CategoriesService } from '../shared/category/categories.service';
import { LoggingService } from '../shared/services/logging/logging.service';

const log = new LoggingService();

export function processResolver(t: Transition, svc: CategoriesService) {
    let process = t.params().process;
    log.verbose({ type: 'processResolver', process, t });
    if (process && process.ProcessID) {
        log.verbose({ type: 'processResolver', process });
        return process;
    } else {
        // if they navigate by entering the url, or refresh the page, we got no process to work with, have to look it up by route
        const processes: fromShared.Process[] = svc
            .getCategories()
            .reduce(
                (a, c) => a.concat(c.UserProcesses as fromShared.Process[]),
                [] as fromShared.Process[]
            );
        process = processes.find(p => {
            if (p.RouteName) {
                return (
                    p.RouteName.toLocaleLowerCase().replace('/', '.') ===
                    t.targetState().name().toLocaleLowerCase()
                );
            }
        });
        if (process) {
            log.verbose({ type: 'processResolver', process });
            svc.updateStoreProcess(process);
            return process;
        } else {
            log.verbose({ type: 'processResolver:no process found' });
            // if (environment.production) {
            t.router.stateService.go('main');
            return {
                ProcessID: 0,
                ProcessDesc: 'Unknown',
                RouteName: '/'
            };
            // }
        }
    }
}
